<script>

    import Moment from 'moment'

    export let icon = 'fa-chart-bar'
    export let badge = 'Periodo'
    export let meta = ''
    export let title = ''
    export let dateStart = null
    export let dateEnd = null

    $: periodLabel = dateStart && dateEnd
        ? `${Moment(dateStart).format('D MMM')} – ${Moment(dateEnd).format('D MMM')}`
        : ''

</script>

<style>
    .stats-card {
        background: #fff;
        border-radius: 28px;
        box-shadow: 0 8px 28px rgba(0, 0, 0, 0.06);
        padding: 1.5rem;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 1.25rem;
        box-shadow: none;
    }

    .logo {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        border: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #1a1a1a;
        font-size: 1.15rem;
    }

    .badge {
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        background: #f2f2f2;
        color: #1a1a1a;
        font-size: 0.8rem;
        font-weight: 500;
        padding: 0.4rem 0.75rem;
        border-radius: 10px;
    }

    .meta {
        display: flex;
        align-items: baseline;
        gap: 0.5rem;
        margin-bottom: 0.35rem;
    }

    .meta-name {
        font-weight: 700;
        color: #1a1a1a;
        font-size: 0.95rem;
    }

    .meta-date {
        color: #9e9e9e;
        font-size: 0.85rem;
    }

    .title {
        font-size: 1.5rem;
        font-weight: 700;
        color: #1a1a1a;
        line-height: 1.2;
        margin: 0 0 0.85rem;
    }

    .footer {
        display: flex;
        align-items: center;
        padding: 16px;
        border-radius: 20px;
        margin-top: auto;
    }

    .footer > :global(*) {
        width: 100%;
    }

    .footer :global(.value) {
        font-size: 1.35rem;
        font-weight: 700;
        color: #1a1a1a;
        line-height: 1.2;
        margin: 0;
    }

    .footer :global(.value.is-danger) {
        color: #c8645c;
    }

    .footer :global(.value.is-success) {
        color: var(--color-primary, #098E37);
    }

    .footer :global(.location) {
        color: #9e9e9e;
        font-size: 0.85rem;
        margin: 0.15rem 0 0;
    }

    .footer :global(.empty) {
        color: #9e9e9e;
        font-size: 0.85rem;
        margin: 0;
        width: 100%;
        text-align: center;
    }
</style>

<div class="stats-card">
    <div class="card-header">
        <div class="logo">
            <i class="fas {icon}"></i>
        </div>
        <span class="badge">
            {badge}
            <i class="fas fa-bookmark"></i>
        </span>
    </div>

    <div class="meta">
        <span class="meta-name">{ meta }</span>
        {#if periodLabel}
            <span class="meta-date">{ periodLabel }</span>
        {/if}
    </div>

    <h3 class="title">{ title }</h3>

    <div class="footer">
        <slot />
    </div>
</div>
